export default "__VITE_PUBLIC_ASSET__350f13e9__"